import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

export default class extends Controller {
  connect() {
    this.mask = IMask(this.element, { mask: '+{7} (000) 000-00-00' });
  }

  disconnect() {
    this.mask?.destroy();
  }
}